export default __webpack_public_path__ + "0fe965d28c2ee5935d08320544e88699.svg";